import { useContextEmpleado } from "../../contexto/empleado/EmpleadoContext";

const AlertaStock = () => {
    const { listaProductosBajoStock = [] } = useContextEmpleado();

    if (listaProductosBajoStock.length === 0) {
        return (
            <span className="dropdown-item text-center text-muted">
                No hay productos con stock bajo
            </span>
        );
    }

    return (
        <>
            {listaProductosBajoStock.map((prod, idx) => (
                <a
                    href="/app/admin/productos/gestionar"
                    key={`${prod.id}-${idx}`}
                    className="dropdown-item"
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-truncate">
                            <i className="fas fa-exclamation-triangle text-warning mr-2" />
                            {prod.nombre}
                        </span>
                        <span className="ml-2 font-weight-bold">Stock: {prod.existencia}</span>
                    </div>
                    <span className="float-right text-muted text-sm">
                        Reorden: {prod.puntoReorden}
                    </span>
                </a>
            ))}
        </>
    );
};

export default AlertaStock;